import $ from "jquery";
import { Klass, u_, csl } from "@pressmedia/webappbase";
import vuwer from "@pressmedia/vuwer";
import "./assets/klass.VuwFileset";

/**
 * VuwFileField (extends VuwField)
 * @options
 * - @required {string} dataType
 * - {boolean} required
 * - {number} ltd
 * - {object} caption: keys->[name, required, ltd, placeholder]
 * - {object} uploadCallbacks: {
 *     begin: function($form) {},
 *     onError: function(message) {},
 *     onSelect: function(selectedFilePath, selectedFileName) {},
 *     onDisSelect: function(paramKey) {},
 *     onFileRead: function(ulFile, res) {},
 *     onUpload: function(res) {},
 *   }
 */
vuwer.appendKlass("VuwFileField", {
	inpType: "file",
	childKlass: "VuwFileset",
	dataType: false,
	
	_initialize: function _initialize(opt) {
		if( Klass("VuwFileField").parent._initialize.call(this, opt) ) {
			if(!this.dataType) {
				csl.warn.red(this.getAddress() + "._initialize() ... no dataType.");
				return false;
			}
			
			// uploadCallbacksが未設定の場合
			u_.isObject(this.uploadCallbacks) || (function(form) {
				if( form && u_.isObject(form.fileUploaderCallbacks) ) {
					// フォームにfileUploaderCallbacksが設定されていれば反映する
					this.uploadCallbacks = form.fileUploaderCallbacks;
				} else {
					this.uploadCallbacks = {};
				}
			}).call( this, this.getForm() );
			
			// [バリデーションの登録]
			// 必須
			this.addValidation("required", function(val) {
				return !this.required || !!val.length;
			}, "必須項目です");
			
			// 数の制限
			this.addValidation("ltd", function(val) {
				return !u_.isNumber(this.ltd) || val.length <= this.ltd;
			}, this.ltd ? String(this.ltd) + "つ以内にして下さい" : "");
			
			return this;
		} else {
			return false;
		}
	},
	
	getInpReady: function getInpReady($self) {
		var tmp = {};
		// get form info
		tmp.form = this.getForm();
		if(tmp.form) {
			this.formConf = {
				ACTION_URL: tmp.form.ACTION_URL
			};
			tmp.maxFileSize = tmp.form.config.maxFileSize;
			if( u_.isObject(tmp.maxFileSize) ) {
				this.formConf.maxFileSize = tmp.maxFileSize[this.dataType];
			}
			if(this.dataType === "video") {
				this.formConf.regardAsFlv = tmp.form.config.regardAsFlv || [];
			}
		}
		
		this.$btnAddFile = $self.find(".btn-addFile");
		!this.$btnAddFile.length && (this.$btnAddFile = false);
		
		$self.on("click", ".btn-addFile", function(e) {
			var
				vuw = $.data(e.delegateTarget, "vuw"),
				$btn = $(this),
				vuwLast, idx;
			
			e.preventDefault();
			if( $btn.hasClass("is-disable") ) {
				return false;
			}
			
			vuwLast = vuw.getLastFileset();
			if( vuwLast && !vuwLast.getState("isSelected") ) {
				// [最後尾のファイルセットが未選択の場合はそちらを使用する]
				vuwLast.$btnSelFile.trigger("click", [true]);
				
			} else {
				// ファイル選択ダイアログを表示
				vuw.$self.hasClass("is-limit") || setTimeout($.fn.trigger.bind($btn, "click", [true]), 100);
				
				// [ファイルセットの追加]
				idx = (vuwLast && vuwLast.name.indexOf("_") >= 0) ? parseInt(vuwLast.name.split("_")[1]) + 1 : false;
				vuw.addFileset(idx, function($self) {
					!!vuwLast && vuwLast.$self.removeClass("is-last");
					$self.addClass("is-last");
				});
			}
		});
		return this;
	},
	
	getDefaultChildProp: function getDefaultChildProp() {
		return {
			vuwType: "fileset",
			dataType: this.dataType,
			formConf: this.formConf,
			caption: this.caption || false,
			selector: (function() {
				return $("<var/>").insertBefore(this.$btnAddFile.$parent);
			}).bind(this)
		};
	},
	
	addFileset: function addFileset(idx, callback) {
		var idx_zp, childProp, df = $.Deferred();
		
		if(this.$self.hasClass("is-limit") || !this.$btnAddFile) {
			csl.log.grey("addFileset ... return");
			return df.reject();
		}
		
		!this.$btnAddFile.$parent && ( this.$btnAddFile.$parent = this.$btnAddFile.parent() );
		u_.isNumber(idx) || (idx = this.getChildren().length + 1);
		idx_zp = u_.zeroPadding(idx, 2);
		
		childProp = this.getDefaultChildProp();
		childProp.paramKey = this.paramKey + "_" + idx_zp;
		u_.isFunction(callback) && (childProp.onReadyLast = callback);
		
		this.add("fileset_" + idx_zp, childProp, function() {
			this.getReady().then( df.resolve.bind(df, this), df.reject.bind(df) );
		});
		
		if(this.ltd && this.getChildren().length === this.ltd) {
			this.$self.addClass("is-limit");
		}
		
		return df.promise();
	},
	
	getLastFileset: function getLastFileset() {
		var children = this.getChildren();
		children.len = children.length;
		if(children.len) {
			return children[children.len - 1];
		} else {
			return undefined;
		}
	},
	
	// [override]
	validate: function validate() {
		var err_cnt = 0;
		this.getChildren().forEach(function(vuwFileset) {
			vuwFileset.validate() || err_cnt++;
		});
		
		if(!err_cnt) {
			Klass("VuwFileField").parent.validate.call(this) || err_cnt++;
		}
		
		return !err_cnt;
	},
	
	setVal: function setVal(value, antiTriggerChange) {
		var promiseList = [];
		// 初期化
		this.removeChildren();
		
		if(this.$self) {
			this.$self.removeClass("is-limit");
			
			if(Array.isArray(value) && value.length && this.$btnAddFile) {
				value.forEach(function(val, i) {
					u_.isObject(val) && promiseList.push( this.addFileset(i + 1, function($self) {
						return this.setVal(val, antiTriggerChange);
					}) );
				}, this);
				
			} else {
				// エラー表示のリフレッシュおよび拡張性を持たせるため、changeイベントをトリガーする
				this.$self.trigger("change", [true]);
			}
		}
		
		return $.when.apply($, promiseList).then( (function() {
			var vuwLast = this.getLastFileset();
			!!vuwLast && vuwLast.$self.addClass("is-last");
		}).bind(this) );
	},
	
	getVal: function getVal() {
		var value = [];
		this.getChildren().forEach(function(vuwFileset) {
			var val = vuwFileset.getVal();
			!!val.ext && value.push(val);
		});
		return value;
	},
	
	getCopiedElement: function getCopiedElement() {
		var $clone = Klass("VuwFileField").parent.getCopiedElement.call(this);
		!!$clone && $clone.children(".btn").remove();
		return $clone;
	},
	
	_getCopiedInp: function _getCopiedInp() {
		var clones = [];
		this.getChildren().forEach(function(vuwFileset) {
			var $clone = vuwFileset.getCopiedElement();
			!!$clone && clones.push($clone);
		});
		return clones;
	},
	
	_renderField: function _renderField() {
		var elms = [];
		elms.push(
			$("<div/>").addClass("btns").append(
				$("<a/>").addClass("btn-addFile").attr("href", "./").append("<span/>")
			)
		);
		
		return $.fn.append.apply(
			$("<div/>").addClass("vuw-field field-file").attr({
				"id": ["field", this.idStr].join("_"),
				"data-name": this.paramKey
			}),
			elms
		);
	}
}, "VuwField");
